import React, { useEffect } from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import clsx from "clsx";
import FaqTab from "./FaqTab";

const MyFaqs = () => {
  // const tabs = ["FAQ", "PRODUCT FAQ"];
  const tabs = ["FAQ"];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="p-5">
      <TabGroup>
        <div className="border-b border-gray-300 dark:border-dark-foreground">
          <TabList className="flex space-x-6 whitespace-nowrap px-2">
            {tabs.map((item: string, index: number) => (
              <Tab key={index} as={React.Fragment}>
                {({ selected }) => (
                  <button
                    className={clsx(
                      "min-h-[54px] text-md px-4 py-2 focus: outline-none",
                      selected
                        ? "border-b-2 border-blue-800 dark:border-blue-400 text-blue-700 dark:text-blue-300 font-bold"
                        : "text-gray-700 dark:text-gray-300 hover:text-blue-600"
                    )}
                  >
                    {item}
                  </button>
                )}
              </Tab>
            ))}
          </TabList>
        </div>

        <TabPanels className="mt-4">
          <TabPanel>
            <FaqTab />
          </TabPanel>
          {/* <TabPanel>
            <ProductFaqTab />
          </TabPanel> */}
        </TabPanels>

        {/* <TabPanels className="mt-4">
          {tabs.map((tab, index) => (
            <TabPanel key={index}>
              <div className="p-4 bg-white shadow rounded">
                Content for: {tab}
              </div>
            </TabPanel>
          ))}
        </TabPanels> */}
      </TabGroup>
    </div>
  );
};

export default MyFaqs;
